<ng-container *transloco="let t;">
<div class="p-grid">
  <div class="p-col-6">
      <h2>{{ t('common.labels.versions') }}</h2>
  </div>
  <div class="p-col-6 p-text-right">
  </div>
</div>

<div *ngIf="exercise !== null">

  <p-table [value]="exercise.versions">
    <ng-template pTemplate="header">
        <tr>
            <th>{{ t('common.labels.id') }}</th>
            <th>{{ t('common.labels.version') }}</th>
            <th>{{ t('common.labels.created_at') }}</th>
            <th>{{ t('common.labels.updated_at') }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-version>
        <tr>
            <td>
              <a withRight="admin.exercise.show" *ngIf="version.hashed_id !== exercise.hashed_id" class="pointer" (click)="openVersion(version)">{{ version.hashed_id }}</a>
              <span *ngIf="version.hashed_id === exercise.hashed_id">{{ version.hashed_id }}</span>
            </td>
            <td>{{ version.version }}</td>
            <td>{{ version.created_at | amDateFormat:'YYYY-MM-DD HH:mm' }}</td>
            <td>{{ version.updated_at | amDateFormat:'YYYY-MM-DD HH:mm' }}</td>
        </tr>
    </ng-template>
  </p-table>

</div>
</ng-container>
